import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";

import "bootstrap/dist/css/bootstrap.min.css";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import "./style/local/all.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Main from "./Main";

ReactDOM.render(
  <Provider store={store}>
    <Main />
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
